<header class="header">
	<div class="header__wrapper">
		<div class="title">
			<h1 class="title__headline"><a [routerLink]="'/portal/stage'" class="logo__link">{{ 'TITLE' | translate }}</a></h1>
		</div>
		<div class="logo">
			<img src="assets/images/logo.svg" alt="Hess" class="logo__image" />
		</div>
	</div>
</header>
<div class="intro" [ngClass]="{'intro--web': environment.webBuild}">
	<video preload="auto" autoplay="1" loop="1" poster="assets/images/poster.jpg" playsinline>
		<source src="assets/videos/intro.mp4" type="video/mp4">
	</video>
	<div class="hotspot hotspot--service-area" (tap)="onClick()" [ngClass]="{'hotspot--hidden' : introStarted}">
		<div class="hotspot__circle-container hotspot--service-area__circle-container">
			<div class="hotspot__inner-circle hotspot--service-area__inner-circle"><i class="fa fa-play-circle hotspot__pin"></i></div>
			<div class="hotspot__outer-circle hotspot--service-area__outer-circle"></div>
		</div>
	</div>
	<div class="info-box" [ngClass]="{'info-box--hidden' : introStarted}">
		<h2 class="info-box__title">{{ 'INTRO.TITLE' | translate }}</h2>
		<h2 class="info-box__subtitle">{{ 'INTRO.SUBTITLE' | translate }}</h2>
		<div class="info-box__wrapper">
			<p class="info-box__description" [innerHTML]="'INTRO.TEXT' | translate"></p>
		</div>
		<div class="info-box__background"></div>
	</div>
</div>
<app-footer *ngIf="environment.webBuild"></app-footer>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/intro/intro.component.html